import NepalNews from './NepalNews';

export default NepalNews;
